export const ShowDeveloperData = window.CODD_MAP_CONFIG?.showDeveloperData === true;

const options = window.CODD_MAP_CONFIG?.developerDataOptions || {};
export const DeveloperDataOptions = {
  mapLoadDetails: ShowDeveloperData && options.mapLoadDetails !== false,
  factorLoadDetails: ShowDeveloperData && options.factorLoadDetails !== false,
  mapTechnicalData: ShowDeveloperData && options.mapTechnicalData !== false,
  factorTechnicalData: ShowDeveloperData && options.factorTechnicalData !== false,
  reportDetails: ShowDeveloperData && options.reportDetails !== false,
};
